import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@nextiva/next-ui-components';

export const blockName = 'location-option';

const renderTitle = option => {
  const { isOneLocation, locationId, label } = option;
  return isOneLocation ? `${locationId} - ${label}` : label;
};

const LocationOption = ({ autoCompleteProps, option, isSelected }) => {
  const { isOneLocation } = option;

  return (
    <li {...autoCompleteProps} data-testid={blockName}>
      <Typography
        component="span"
        sx={[
          {
            fontWeight: isSelected ? 'bold' : 'regular',
          },
          !isOneLocation && {
            textIndent: '30px',
          },
        ]}
      >
        {renderTitle(option)}
      </Typography>
    </li>
  );
};

LocationOption.defaultProps = {
  isSelected: false,
};

LocationOption.propTypes = {
  autoCompleteProps: PropTypes.object.isRequired,
  option: PropTypes.object.isRequired,
  isSelected: PropTypes.bool.isRequired,
};

export default LocationOption;
